<template>
  <!-- <div class="card"> -->
    <form>
      <!-- <div class="card-content"> -->
        <div class="row">
          <!-- <p class="clearfix"> </p> -->
          <div class="col-sm-12 ">
            <div class="form-group">
              <label>{{$t('settingsRewards.state')}}</label>
              <!-- <br/> -->
              <p-switch v-model="model.loyalty_in_use" type="success" @input="handleActive($event)"></p-switch>
            </div>
            <div v-if="model.loyalty_in_use">
              <div class="form-group">
                <label>{{$t('settingsRewards.moneySpent')}}</label>
                <br/>
                1 {{currency}} = <input type="number"
                       min="1" 
                       step="0.1" 
                       name="loyalty_value_one_currency"
                       v-validate="modelValidations.loyalty_value_one_currency"
                       v-model="model.loyalty_value_one_currency"
                       class="form-control in-inline"> {{$t('settingsRewards.plural')}}
                <span class="help-block">{{$t('settingsRewards.numberOfcurrencyNeedToSpend')}}</span>
                <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                  {{ getError('loyalty_value_one_currency') }}
                </small>
              </div>
              <div class="form-group">
                <label>{{$t('settingsRewards.pointsTo')}}</label>
                <br/>
                <input type="number"
                       min="1" 
                       default="1"
                       step="0.1" 
                       name="loyalty_value_one_point_amount"
                       v-validate="modelValidations.loyalty_value_one_point_amount"
                       v-model="model.loyalty_value_one_point_amount"
                       class="form-control in-inline"> 
                {{$t('settingsRewards.points')}} = <input type="number"
                       min="0" 
                       default="1"
                       step="0.1" 
                       name="loyalty_value_one_point"
                       v-validate="modelValidations.loyalty_value_one_point"
                       v-model="model.loyalty_value_one_point"
                       class="form-control in-inline"> {{currency}}
                <span class="help-block">{{$t('settingsRewards.numberOfpointsToReward')}}</span>
                <small class="text-danger" v-if="errors.has('loyalty_value_one_point')">
                  {{ getError('loyalty_value_one_point') }}
                </small>
              </div>
              <div class="mar-bt-5">
                <button type="submit" @click.prevent="validate" class="btn btn-success btn-fill">{{$t('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
      
   <!--    <div class="card-footer">
        
      </div> -->
    </form>

  <!-- </div> -->
</template>
<script>
  import Vue from 'vue'
  import {Input, Button, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      PSwitch
    },
    props: {
      defaultData: {},
      modeldata: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        value.loyalty_value_one_point_amount = Math.round(value.loyalty_value_one_point_amount * 10) / 10
        this.model = value
      }
    },
    data () {
      return {
        model: [],
        defaults: this.value || this.defaultData, // this.countries
        modelValidations: {
          loyalty_value_one_point: { required: true },
          loyalty_value_one_point_amount: { required: true },
          loyalty_value_one_currency: { required: true }
        },
        currency: ''
      }
    },
    created () {
      let currency = this.$session.get('selectedCompanyData').price_details
      if (currency !== undefined) {
        this.currency = this.decodeHtml(currency.symbol)
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
          }
        }
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'loyalty_value_one_currency': this.model.loyalty_value_one_currency,
          'loyalty_value_one_point_amount': this.model.loyalty_value_one_point_amount,
          'loyalty_value_one_point': this.model.loyalty_value_one_point
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.$session.set('selectedCompanyData', response.data[0])
          } else {
            self.handleErrors(response.errors)
            // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
          }
        })
      },
      handleActive (e) {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'loyalty_in_use': this.model.loyalty_in_use ? 1 : 0
        }
        let actionText = this.model.loyalty_in_use ? 'enabled' : 'disabled'
        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            self.handleErrors(response.errors)
            self.model.loyalty_in_use = !self.model.loyalty_in_use
            swal(
              '',
              response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/RewardProgram/RewardProgramForm.vue